import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { PhoneCall, List, X, Wrench } from "@phosphor-icons/react";
import { BUSINESS } from "../data/constants";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/areas", label: "Service Areas" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur-xl border-b border-[#E2E8F0]"
    >
      <div className="mx-auto max-w-7xl flex items-center justify-between gap-4 px-4 md:px-6 py-3 md:py-4">
        <Link
          to="/"
          data-testid="header-logo-link"
          className="flex items-center gap-2 font-display font-black text-[#1B2A4A] text-lg md:text-xl tracking-tight"
        >
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-sm bg-[#1B2A4A] text-white">
            <Wrench size={20} weight="fill" className="text-[#FF6B00]" />
          </span>
          <span className="leading-none">
            GTA <span className="text-[#FF6B00]">Garage</span> Doors
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/ /g, "-")}`}
              className={({ isActive }) =>
                `text-sm font-bold font-display tracking-tight transition-colors ${isActive ? "text-[#FF6B00]" : "text-[#1B2A4A] hover:text-[#FF6B00]"}`
              }
              end={n.to === "/"}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href={BUSINESS.phoneHref}
            data-testid="header-call-now-button"
            className="inline-flex items-center gap-2 rounded-sm bg-[#FF6B00] text-white font-bold font-display px-4 py-2.5 md:px-5 md:py-3 text-sm md:text-base hover:bg-[#E66000] transition-all hover:-translate-y-0.5 shadow-md"
          >
            <PhoneCall size={18} weight="fill" />
            <span className="hidden sm:inline phone-number">{BUSINESS.phone}</span>
            <span className="sm:hidden">Call Now</span>
          </a>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen(!open)}
            className="lg:hidden inline-flex items-center justify-center h-10 w-10 rounded-sm border border-[#E2E8F0] text-[#1B2A4A] hover:bg-[#F8FAFC]"
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <List size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden border-t border-[#E2E8F0] bg-white"
        >
          <nav className="flex flex-col px-4 py-2">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/ /g, "-")}`}
                className={({ isActive }) =>
                  `py-3 border-b border-[#F1F5F9] text-base font-bold font-display ${isActive ? "text-[#FF6B00]" : "text-[#1B2A4A]"}`
                }
                end={n.to === "/"}
              >
                {n.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
